const tableNumberEnum = {
    /**
     * enum utile pour les rapport à tableau multiple nécessitant quand même une sélection par site multiple
     */
    TABLE_ONE: 0,
    TABLE_TWO: 1,
    TABLE_THREE: 2,
}

export default tableNumberEnum;
